import { StakingRewards } from "@/features/treasury/treasury";

export default function TreasuryStakingRewardsPage() {
  return <StakingRewards />;
}
